import type { BillingSubscription } from '@store/api/billing/billingApi';
import { isInactivePaidSubscription } from './billingPlans';

/** Paid access was purchased but subscription is no longer active; Free limits apply on the backend. */
export function isInactiveProSubscription(
  subscription: BillingSubscription | null | undefined
): boolean {
  return isInactivePaidSubscription(subscription);
}
